import React, {useEffect} from 'react';
import './FernrauschApp.scss';
import PopupMenuView from '../popupmenu/PopupMenuView';
import {useModel} from '../../model/Model';
import {Breakpoint, getBreakpoint} from '../../utils/Breakpoint';
import {Events, EventType} from '../../events/Events';
import DesktopViewport from './DesktopViewport';
import MobileViewport from './MobileViewport';

const FernrauschApp = () => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>();

  const model = useModel((model) => {
    console.info('Model is available', model);
  });

  useEffect(() => {
    setBreakpoint(getBreakpoint());

    Events.subscribe(EventType.BREAKPOINT_CHANGED, () => {
      setBreakpoint(getBreakpoint());
    });
  }, []);

  function renderViewport(): React.ReactNode {
    if (breakpoint == null || model == null) {
      return 'Loading...';
    }

    if (breakpoint === Breakpoint.PHONE) {
      return (
          <MobileViewport
              trip={model.trip}
              googleMapsApiKey={model.googleMapsApiKey}
          />
      );
    } else {
      return (
          <DesktopViewport
              trip={model.trip}
              googleMapsApiKey={model.googleMapsApiKey}
          />
      );
    }
  }

  return <React.Fragment>
    <header>
    </header>
    <main>
      <div id="breakpoint-detector"></div>
      {renderViewport()}
      <PopupMenuView/>
    </main>
  </React.Fragment>;
};

export default FernrauschApp;
